import React, { useEffect, useRef } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div } from "components/Base";
import {
  getWelcomeData,
  getFormTitleSize,
  getFormTitleColor
} from "Portal/CallForPapersForm/selectors";
import NextButton from "./NextButton";

const decorate = connect(
  state => ({
    data: getWelcomeData(state),
    formTitleSize: getFormTitleSize(state),
    formTitleColor: getFormTitleColor(state)
  }),
  {}
);

const IMAGE_FILE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "svg",
  "raw",
  "tiff",
  "heic",
  "bmp",
  "webp"
];

const getFileNameAsAlt = name => {
  let formattedName = "";
  IMAGE_FILE_EXTENSIONS.forEach(type => {
    if (name && name.includes(`.${type}`)) {
      formattedName = name.split(`.${type}`)[0].replaceAll("_", " ");
    }
  });
  return formattedName;
};

const WelcomePage = ({ data, formTitleColor, formTitleSize }) => {
  const ref = useRef(null);
  useEffect(() => {
    const { current } = ref;
    if (current) {
      const anchors = current.querySelectorAll("a");
      if (anchors.length) {
        anchors.forEach(anchor =>
          anchor.setAttribute(
            "aria-label",
            `Link - ${anchor.textContent || anchor.innnerText} - New tab`
          )
        );
      }
      const images = current.querySelectorAll("img");
      if (images.length) {
        images.forEach(image => {
          if (!image.getAttribute("alt")) {
            image.setAttribute(
              "alt",
              getFileNameAsAlt(image.getAttribute("title"))
            );
          }
        });
      }
    }
  }, [ref]);
  return (
    <Div>
      <Div mb={6} aria-label="main" role="main">
        <h1
          tabIndex={0}
          style={{ color: formTitleColor, fontSize: formTitleSize }}
        >
          {R.propOr("", "title", data)}
        </h1>
        {R.propOr(false, "show_description", data) && (
          <Div
            color="gray8"
            fs={3}
            className="lennd-wysiwyg-content portal-message-text"
          >
            <span
              ref={ref}
              dangerouslySetInnerHTML={{
                __html: R.propOr("", "description", data)
              }}
            />
          </Div>
        )}
      </Div>
      <Div display="row.space-between.center" aria-label="footer" role="footer">
        <NextButton />
      </Div>
    </Div>
  );
};

export default decorate(WelcomePage);
